module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_7.3f993f00.pdf";